import axios from 'axios';
import pako from 'pako';
import CryptoJS from 'crypto-js';
/* eslint-disable */

const axiosInstance = axios.create();

function xsint_protection_0(length) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghjklmnopqrstuwxyz123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length); 
      result += characters[randomIndex]; 
  }
  return result;
}

const randomString = xsint_protection_0(142);


function a() {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz123456789';
  return characters.charAt(Math.floor(Math.random() * characters.length));
}

function z(g, h) {
  const position = Math.floor(Math.random() * (g.length - h.length));
  return g.slice(0, position) + h + g.slice(position);
}

function e(m) {
  let j = '';
  for (let i = 0; i < m; i++) {
      j += a();
  }
  return j;
}

function xsint_protection_03() {
  const x = e(442);
  const v = z(x, 'xnb3');
  return v;
}

function encrypt_data(data) {
  const secretKey = 'CONTACTMEONSUPPORT@XSINT-INTELLIGENCE.COM'; 
  const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
  return ciphertext
}



axiosInstance.interceptors.request.use(config => {
    let randomString = xsint_protection_0(500);
    config.headers['']
    config.headers['x-xsint-protection0'] = randomString;
    //config.headers['x-xsint-protection02'] = "indev";
    //config.headers['x-xsint-protection03'] = "indev"
    config.headers['x-xsint-protection04'] = xsint_protection_03();
    if (config.data) {
        config.data = pako.gzip(encrypt_data(JSON.stringify(config.data)));
        config.headers['Content-Encoding'] = 'gzip';
        config.headers['Content-Type'] = 'application/json';
    }
    return config;
}, error => {
    return Promise.reject(error);
});

export default {
    install(app) {
        app.config.globalProperties.$axios = axiosInstance;
    }
};
